// extracted by mini-css-extract-plugin
export default {"section-breaks__input--full-width":"section-breaks__input--full-width--aa_1r","sectionBreaksInputFullWidth":"section-breaks__input--full-width--aa_1r"};